import React from 'react';
import { Button as SemanticButton, Icon, Modal } from 'semantic-ui-react';

import { CommissioningCollaborator } from '../types';

type Props = {
  open: boolean;
  collaborator: CommissioningCollaborator | null;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteCollaboratorModal: React.FC<Props> = ({
  open,
  collaborator,
  loading = false,
  onClose,
  onConfirm
}) => {
  return (
    <Modal open={open} onClose={onClose} size="tiny" closeIcon>
      <Modal.Header>
        <Icon name="trash alternate" /> Excluir colaborador
      </Modal.Header>
      <Modal.Content>
        <h4 style={{ margin: '0 0 10px' }}>
          Você está prestes a excluir um colaborador comissionado.
        </h4>
        <p style={{ color: '#4f5661', fontSize: 13, lineHeight: 1.45, margin: 0 }}>
          Ao confirmar a exclusão, esse colaborador não será mais exibido como apto
          para receber comissionamento de cobranças. Deseja continuar?
        </p>
        {collaborator && (
          <p style={{ color: '#666', fontSize: 13, margin: '12px 0 0' }}>
            Colaborador: <strong>{collaborator.name}</strong>
          </p>
        )}
      </Modal.Content>
      <Modal.Actions>
        <SemanticButton
          type="button"
          color="red"
          onClick={onClose}
          disabled={loading}
        >
          <Icon name="remove" /> Cancelar
        </SemanticButton>
        <SemanticButton
          type="button"
          color="green"
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          <Icon name="check" /> Confirmar
        </SemanticButton>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteCollaboratorModal;
